import { render, staticRenderFns } from "./StatList.vue?vue&type=template&id=c06c0ff2&"
import script from "./StatList.vue?vue&type=script&lang=js&"
export * from "./StatList.vue?vue&type=script&lang=js&"
import style0 from "./StatList.vue?vue&type=style&index=0&id=c06c0ff2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports